import images from "./images";

const gallery = [
  {
    id: 1,
    image: images.coffee1,
    title: 'Latte',
    category: 'coffee',
  },
  {
    id: 2,
    image: images.drink1,
    title: 'Hot Chocolate',
    category: 'hot drinks',
  },
  {
    id: 3,
    image: images.dessert1,
    title: 'Croissant',
    category: 'desserts',
  },
  {
    id: 4,
    image: images.coffee2,
    title: 'Cappuccino',
    category: 'coffee',
  },
  {
    id: 5,
    image: images.drink2,
    title: 'Black Tea',
    category: 'hot drinks',
  },
  {
    id: 6,
    image: images.dessert2,
    title: 'Cupcake',
    category: 'desserts',
  },
  {
    id: 7,
    image: images.coffee3,
    title: 'Black Coffee',
    category: 'coffee',
  },
  {
    id: 8,
    image: images.drink3,
    title: 'Earl Grey',
    category: 'hot drinks',
  },
  {
    id: 9,
    image: images.dessert3,
    title: 'Cupcake',
    category: 'desserts',
  },
];

export default gallery;